import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, throwError, switchMap } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root',
})
export class ComisionesService {
  // private baseUrl = 'http://localhost:9180/ova/api/datos/comisiones';
  private baseUrl = `${ENV.HOST}${URL_MAP.API.COMISIONES}`;
  private comprobanteBlobUrl = `${this.baseUrl}/comprobante`;
  private codigoAsoresorUrl = `${ENV.HOST}${URL_MAP.API.CODIGOASESOR}`;

  constructor(private http: HttpClient) {}

  private crearParams(params: { [key: string]: string }): HttpParams {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params[key]) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    return httpParams;
  }

  getTipoUsuario(codAsesor: string): Observable<string> {
    if (!codAsesor) return throwError(() => new Error('Código Asesor vacío'));
    const params = this.crearParams({ numDocUsuario: codAsesor });
    return this.http
      .get(`${this.baseUrl}/tipo-usuario`, { params, responseType: 'text' })
      .pipe(
        catchError((error) => {
          console.error('Error al obtener tipo de usuario:', error);
          return throwError(() => error);
        })
      );
  }

  getComisionesPorTipo(tipo: 'INTERNO' | 'EXTERNO'): Observable<any> {
    if (!tipo) return throwError(() => new Error('Tipo vacío'));
    const params = this.crearParams({ userType: tipo });
    return this.http.get(this.baseUrl, { params }).pipe(
      catchError((error) => {
        console.error('Error al obtener comisiones:', error);
        return throwError(() => error);
      })
    );
  }

  obtenerPeriodosValidos(
    anio: number,
    tipoUsuario: 'INTERNO' | 'EXTERNO'
  ): Observable<string[]> {
    const params = this.crearParams({
      anio: anio.toString(),
      tipoUsuario: tipoUsuario,
    });

    return this.http
      .get<string[]>(`${this.baseUrl}/periodos-validos`, { params })
      .pipe(
        catchError((error) => {
          console.error('Error al obtener períodos válidos:', error);
          return throwError(() => error);
        })
      );
  }

  consultarCodigoAsesor(documento: string): Observable<{ idasesor: number, tipoAsesor: string }> {
    const body = {
      nombreClave: 'getSpAsesorDocumento',
      jsonParametros: JSON.stringify({ prm_docu_asesor: documento }),
    };

    return this.http
      .post<any>(
        this.codigoAsoresorUrl,
        body
      )
      .pipe(
        map((resp) => {
          const asesor = resp?.data?.[0];
          return {
            idasesor: asesor?.idasesor,
            tipoAsesor: asesor?.TipoAsesor, // <-- aquí extraemos el TipoAsesor
          };
        }),
        catchError((err) => {
          console.error('❌ Error consultando asesor:', err);
          return throwError(() => err);
        })
      );
  }

  descargarComprobanteGeneral(
    anio: number,
    periodo: string,
    codAsesor: string,
    tipoUsuario: string,
    // tipoUsuario: 'INTERNO' | 'EXTERNO',
    quincena?: string,
    nombreAsesor?: string,
    identificacion?: string
  ): Observable<HttpResponse<Blob>> {
    const documentoParam =
      tipoUsuario === 'INTERNO' ? codAsesor : identificacion;
    const identificacionParam = identificacion || '';
    return this.consultarCodigoAsesor(codAsesor).pipe(
      
      switchMap((asesor) => {
        const params: any = {
          anio: anio.toString(),
          mes: periodo,
          documento: asesor.idasesor?.toString() || identificacion || '',
          // tipoUsuario,
          tipoUsuario: asesor.tipoAsesor?.toString() || tipoUsuario,
          tipoArchivo: tipoUsuario === 'INTERNO' ? 'Deta' : 'Comp',
          name: nombreAsesor || '',
          identificacion: identificacionParam, 
        };

        if (tipoUsuario === 'EXTERNO' && quincena) {
          params.quincena = quincena;
        }

        console.log('📤 Params descargarComprobanteGeneral:', params);

        return this.http.get(this.comprobanteBlobUrl, {
          params: this.crearParams(params),
          observe: 'response',
          responseType: 'blob',
        });
      })
    );
  }

  descargarZipExterno(
    anio: number,
    periodo: string,
    codAsesor: string,
    tipoUsuario: 'EXTERNO',
    nombreAsesor: string,
    identificacion: string
  ): Observable<HttpResponse<Blob>> {
    return this.consultarCodigoAsesor(codAsesor).pipe(
      switchMap((asesor) => {
    const params = this.crearParams({
      anio: anio.toString(),
      periodo,
      documento: asesor.idasesor?.toString() || identificacion || '',
      tipoUsuario,
      name: nombreAsesor,
      identificacion: identificacion,
    });

    return this.http.get(`${this.baseUrl}/descargar-externo`, {
      params,
      observe: 'response',
      responseType: 'blob',
    });
    })
    );
  }

  consultarComprobantes(dto: { jsonParametros: string }): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/asesores-externos-ova-comprobantes`, dto)
      .pipe(
        catchError((error) => {
          console.error('Error al consultar comprobantes desde OVA:', error);
          return throwError(() => error);
        })
      );
  }

  consultarDetallado(dto: { jsonParametros: string }): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/asesores-externos-ova-detallado`, dto)
      .pipe(
        catchError((error) => {
          console.error('Error al consultar detallado desde OVA:', error);
          return throwError(() => error);
        })
      );
  }
}
